import React, { useState } from "react";
import {
  Button,
  FlexRowBetween,
  Input,
  Label,
  PopupForm,
  TextArea,
} from "../../common/Style";
import { useForm } from "react-hook-form";
import { CFV } from "../../common/others/Functions";
import OpacityLoading from "../../common/loader/OpacityLoading";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { add } from "../../../store/reducers/todosReducer";
import GCalendar from "../../common/calendar/Calendar";
import GenericModal from "../../common/modals/GenericModal";
import { editDetails } from "../../../store/reducers/authReducer";

const AddTables = ({ init }) => {
  const { user } = useSelector((state) => state.authReducer);
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [loading, setLoading] = useState(false);

  const onSubmit = async (data) => {
    let arr = [];

    // חשב את הגודל הממוצע של השולחנות הקיימים
    let avgWidth = 60;
    let avgHeight = 60;

    if (user.tablesArray.length > 0) {
      const totalWidth = user.tablesArray.reduce(
        (sum, table) => sum + (table.width || 60),
        0
      );
      const totalHeight = user.tablesArray.reduce(
        (sum, table) => sum + (table.height || 60),
        0
      );
      avgWidth = Math.round(totalWidth / user.tablesArray.length);
      avgHeight = Math.round(totalHeight / user.tablesArray.length);
    }

    for (let i = 0; i < data.tables; i++)
      arr.push({
        amount: parseInt(data.amount),
        chairs: parseInt(data.amount),
        default: false,
        title: data.title,
        shape: data.shape || "square", // Save the shape
        width: 60, // השתמש בגודל הממוצע
        height: 60, // השתמש בגודל הממוצע
        x: 20, // ערך ברירת מחדל
        y: 80, // ערך ברירת מחדל
      });
    setLoading(true);
    dispatch(editDetails({ tablesArray: user.tablesArray.concat(arr) })).then(
      (res) => {
        setLoading(false);
        if (!res.payload?.error) {
          toast.success("הפעולה בוצעה בהצלחה");
          init();
        } else toast.error(res.payload?.error);
      }
    );
  };

  return (
    <PopupForm
      onClick={(e) => e.stopPropagation()}
      onSubmit={handleSubmit(onSubmit)}
      className="animate__animated animate__fadeIn"
    >
      <div
        style={{
          width: "90%",
          margin: "15px auto",
        }}
      >
        <Label>כותרת</Label>
        <Input
          type="text"
          defaultValue={"כללי"}
          {...register("title", {
            required: true,
            minLength: 1,
            maxLength: 50,
          })}
        />
        {CFV("title", "מספר בין 1 ל 50", errors)}

        <FlexRowBetween>
          <div style={{ width: "45%" }}>
            <Label>כמות שולחנות</Label>
            <Input
              type="number"
              {...register("tables", {
                required: true,
                min: 1,
                max: 150,
              })}
            />
            {CFV(`tables`, `מספר בין 1 ל 150`, errors)}
          </div>
          <div style={{ width: "45%" }}>
            <Label>מספר סועדים</Label>
            <Input
              type="number"
              {...register("amount", {
                required: true,
                min: 1,
                max: 300,
              })}
            />
            {CFV(`amount`, `מספר בין 1 ל 300`, errors)}
          </div>
        </FlexRowBetween>

        <div style={{ width: "100%", marginTop: "15px" }}>
          <Label>צורה</Label>
          <select
            defaultValue="square"
            {...register("shape", {
              required: true,
            })}
            style={{
              width: "100%",
              padding: "8px",
              border: "1px solid #ddd",
              borderRadius: 4,
              fontSize: "14px",
            }}
          >
            <option value="square">ריבועי</option>
            <option value="circle">עגול</option>
          </select>
        </div>

        <FlexRowBetween style={{ marginTop: "30px" }}>
          <Button style={{ width: "100%" }}>הוספה</Button>
        </FlexRowBetween>
      </div>

      {loading && <OpacityLoading />}
    </PopupForm>
  );
};

export default AddTables;
